import MessageBox from 'element-ui/packages/message-box'
import Message from 'element-ui/packages/message'
import Notification from 'element-ui/packages/notification'

export default {
  methods: {
    $_apiAlertMixin_success: function (message, type, confirmText) {
      switch (type) {
        case 'notify':
          return Notification({ title: 'Success!', type: 'success', message: message, position: 'bottom-right', dangerouslyUseHTMLString: true, duration: 4000 })
        case 'message':
          return Message({ type: 'success', showClose: true, message: message, dangerouslyUseHTMLString: true, duration: 4000 })
        case 'alert':
          return MessageBox.alert(message, 'Success!', { type: 'success', showClose: true, confirmButtonText: confirmText ? confirmText : 'OK', dangerouslyUseHTMLString: true })
        default:
          return Notification({ title: 'Success!', type: 'success', message: message, position: 'bottom-right', dangerouslyUseHTMLString: true, duration: 4000 })
      }
    },
    $_apiAlertMixin_error: function (error, type) {
      if ( !error || error == undefined || error == null || error == "" || !error.messages || error.messages.length < 1 ) {
        console.log(error)
        return
      }
      let code = error.code ? error.code : '500'
      let codeText = code === 200 ? `Sorry...` : `${code} Error`
      let message = error ? error.messages.join('<br>') : 'サーバー側でエラーが発生しました。もう一度お試しください。'
      switch (type) {
        case 'notify':
          return Notification({ title: codeText, type: 'error', message: message, position: 'bottom-right', dangerouslyUseHTMLString: true, duration: 4000 })
        case 'message':
          return Message({ type: 'error', showClose: true, message: message, dangerouslyUseHTMLString: true, duration: 4000 })
        case 'alert':
          return MessageBox.alert(message, codeText, { type: 'error', showClose: true, confirmButtonText: 'OK', dangerouslyUseHTMLString: true })
        default:
          return MessageBox.alert(message, codeText, { type: 'error', showClose: true, confirmButtonText: 'OK', dangerouslyUseHTMLString: true })
      }
    }
  }
}
